import {useTranslation} from 'react-i18next';
import EventMaxWidthV4 from './EventMaxWidthV4';
import DescText from '../../common/component/DescText';
import Text from '../../common/component/Text';
import {IBottomModuleV4} from '../type';

interface IProps {
  data: IBottomModuleV4;
}

export default function BottomModuleV4({data}: IProps) {
  const {t} = useTranslation();
  const {startDate, endDate, rewardDescription, detailDescriptions} = data;

  return (
    <div className="bg-black pt-40 pb-60" data-module-type="bottom">
      <EventMaxWidthV4>
        <Text className={TITLE_CN}>{t('crm_bottom_event_period')}</Text>
        <Text className={DESC_MT_CN}>
          {startDate} ~ {endDate}
        </Text>
        {rewardDescription && (
          <div className="mt-30">
            <Text className={TITLE_CN}>{t('crm_bottom_reward_title')}</Text>
            <Text className={DESC_MT_CN}>{rewardDescription}</Text>
          </div>
        )}
        <div className="h-1 bg-light-grey-10 my-30" />
        <Text className={TITLE_CN}>{t('crm_bottom_notice')}</Text>
        <div className="mt-5">
          {detailDescriptions.map((text, index) => (
            <DescText key={index} className={cn(DESC_CN, '!leading-23')}>
              {text}
            </DescText>
          ))}
        </div>
      </EventMaxWidthV4>
    </div>
  );
}

const TITLE_CN = 's14-semibold-white leading-17 tracking-[-0.4px]';
const DESC_CN =
  's13-regular-grey06 leading-19 tracking-[-0.4px] !text-dark-grey-10';
const DESC_MT_CN = cn(DESC_CN, 'mt-5');
